import React from 'react';
import { MarketingImage_Root } from './MarketingImage.styles';

export const MarketingImage = () => (
    <MarketingImage_Root>
        <img
            alt='RWTS-Track' id='marketingImage'
            src='https://staticnavegatecom.blob.core.windows.net/static/images/navegate/RWTS-Track-powered-by-Navgate.png'
        />
    </MarketingImage_Root>
);
